module.exports = __webpack_public_path__ + "static/media/jackpots-lvl2.00106d00.png";